/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';

export enum InsightsPanelActions {
  OpenSidePanel = '[MapsInsightsPanel] Open Insights Panel',
  CloseSidePanel = '[MapsInsightsPanel] Close Insights Panel',
  ChangeOpenCloseStateSidePanel = '[MapsInsightsPanel] Change Open Close State Insights Panel'
}

export class OpenInsightsPanel implements Action {
  public readonly type = InsightsPanelActions.OpenSidePanel;
}

export class CloseInsightsPanel implements Action {
  public readonly type = InsightsPanelActions.CloseSidePanel;
}

export class ChangeOpenCloseStateSidePanel implements Action {
  public readonly type = InsightsPanelActions.ChangeOpenCloseStateSidePanel;
}

export type InsightsPanelActionsType = OpenInsightsPanel | CloseInsightsPanel | ChangeOpenCloseStateSidePanel;
